import {Grid} from "@mui/material";
import styles from 'assets/css/BarChartStyle.module.css'
import {PointInRangeChart} from './PointInRangeChart'
import Six from 'assets/img/barchartIcons/00-6.svg';
import Eight from 'assets/img/barchartIcons/6_8.svg';
import Ten from 'assets/img/barchartIcons/8_10.svg';
import Twelve from 'assets/img/barchartIcons/10_12.svg';
import Fourteen from 'assets/img/barchartIcons/12_14.svg';
import Sixteen from 'assets/img/barchartIcons/14_16.svg';
import EightTeen from 'assets/img/barchartIcons/16_18.svg';
import Twenty from 'assets/img/barchartIcons/18_20.svg';
import TwentyTwo from 'assets/img/barchartIcons/20-22.svg';
import TwentyFour from 'assets/img/barchartIcons/22-24.svg';
import {digitsEnToFa} from "persian-tools2";


const images = [
    {id: 0, img: <img src={Six} alt=''/>},
    {id: 1, img: <img src={Eight} alt=''/>},
    {id: 2, img: <img src={Ten} alt=''/>},
    {id: 3, img: <img src={Twelve} alt=''/>},
    {id: 4, img: <img src={Fourteen} alt=''/>},
    {id: 5, img: <img src={Sixteen} alt=''/>},
    {id: 6, img: <img src={EightTeen} alt=''/>},
    {id: 7, img: <img src={Twenty} alt=''/>},
    {id: 8, img: <img src={TwentyTwo} alt=''/>},
    {id: 9, img: <img src={TwentyFour} alt=''/>},
];

export const BarChartRowContainer = (props) => {
    const {
        index, hour, glucoseAverage,
        recordCount, isHypo, emptyRow, lowGlucoseWidth,
        inRangeGlucoseWidth, highGlucoseWidth
    } = props.barChartRowData
    return (
        <Grid container className={index % 2 === 0 ?styles.evenRow
                    : styles.oddRow}>
            {/*first column*/}
            <Grid item xs={3}
                  className={styles.hourContainer}>
                {images[index].img}
                <span className={styles.hourStyle}>{digitsEnToFa(hour)}</span>
            </Grid>
            {/*second column*/}
            <Grid item xs={5} >
                <PointInRangeChart emptyRow={emptyRow} lowGlucoseWidth={lowGlucoseWidth}
                                   inRangeGlucoseWidth={inRangeGlucoseWidth} highGlucoseWidth={highGlucoseWidth}/>
            </Grid>
            {/*third column*/}
            <Grid item xs={1.5} className={styles.centerContainer}>
                <p className={`${styles.avgStyle} ${isHypo && styles.hypStyle}`}>
                    {Math.round(glucoseAverage)===0?digitsEnToFa('0'):
                        digitsEnToFa(Math.round(glucoseAverage))}</p>
            </Grid>
            {/*forth column*/}
            <Grid item xs={2.5} className={styles.centerContainer}>
                <p className={styles.avgStyle}>{recordCount===0?digitsEnToFa('0'):
                    digitsEnToFa(recordCount)}</p>
            </Grid>
        </Grid>
    )
}